import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from '@/store';
import { isFieldUser } from '@/utils/roleHelpers';
import { env } from '@/config/env';

interface FieldUserRouteProps {
  children: React.ReactElement;
}

/**
 * Protected route wrapper for field user pages (Driver, Monitor, SpStaff)
 * Redirects non-field users to dashboard
 */
const FieldUserRoute: React.FC<FieldUserRouteProps> = ({ children }) => {
  const { user, isAuthenticated } = useAppSelector((state) => state.auth);

  // Bypass guard when authentication is disabled (development mode)
  if (!env.authEnabled && !env.authorizationEnabled) {
    return children;
  }

  // If not authenticated, redirect to login (handled by AuthGuard)
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // If authenticated but not a field user, redirect to dashboard
  if (!user || !isFieldUser(user.roles)) {
    return <Navigate to="/dashboard" replace />;
  }

  // User is a field user, render the protected component
  return children;
};

export default FieldUserRoute;
